import { render, staticRenderFns } from "./PurchaseModal.vue?vue&type=template&id=fa12352a&scoped=true"
import script from "./PurchaseModal.vue?vue&type=script&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseModal.vue?vue&type=style&index=0&id=fa12352a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa12352a",
  null
  
)

export default component.exports